import { IoMdArrowDropdown } from "react-icons/io";
import { RxCross1 } from "react-icons/rx";
import { useState } from "react";

interface LocationFilterProps {
    selectedCountry: string;
    selectedCity: string;
}

interface City {
    cityName: string;
}
interface Location {
    country: string;
    cities: City[];
}
export const LocationData: Location[] = [
    {
        country: "India",
        cities: [
            { cityName: "Ahmedabad" },
            { cityName: "Bengaluru" },
            { cityName: "Bhubaneshwar" },
            { cityName: "Chennai" },
            { cityName: "Delhi" },
            { cityName: "Gurugram" },
            { cityName: "Gurgaon" },
            { cityName: "Hyderabad" },
            { cityName: "Kochi" },
            { cityName: "Mumbai" },
            { cityName: "Pune" },
        ],
    },
];

export const LocationFilter: React.FC<LocationFilterProps> = ({ selectedCountry, selectedCity }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <div className="relative" id="location-dropdown">
            <div
                onClick={toggleDropdown}
                className="border border-solid px-2 py-3 md:py-1 border-gray-200 bg-gray-50 cursor-pointer flex items-center justify-between md:w-fit w-full rounded-md drop-down-agency"
            >
                <span className="flex items-center">{selectedCity ? `${selectedCity}, ${selectedCountry}` : selectedCountry ? selectedCountry : "Select Location"}</span>
                <span className="ml-2">{isOpen ? <RxCross1 /> : <IoMdArrowDropdown />}</span>
            </div>

            {isOpen && (
                <div className="absolute z-50 bg-white border shadow md:w-96 max-h-64 overflow-y-auto w-full drop-list">
                    {LocationData.map((loc) => (
                        <div key={loc.country}>
                            <a href={`/agencies/${loc.country.toLowerCase()}`} className="block font-semibold px-3 py-1 hover:bg-gray-100 cursor-pointer">
                                {loc.country}
                            </a>

                            {loc.cities.map((city) => (
                                <a
                                    href={`/agencies/${loc.country.toLowerCase()}/${city.cityName.toLowerCase()}`}
                                    key={city.cityName}
                                    className="block ml-5 px-3 py-1 hover:bg-gray-100 cursor-pointer"
                                >
                                    {city.cityName}
                                </a>
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
